
import http from '@/components/services/http-common';
import CreateButton from '@/components/Crud/CreateButton';
import DataFilter from '@/components/DataFilter';
import CreateDialog from '../Create.vue';
import CreateDialog2 from '../Create2.vue';
import * as moment from "moment/moment"
import ApiServices from '../../../../components/services/ApiServices';
import MyBreadcrumb from '@/components/MyBreadcrumb'

export default {
    name: "Attendance",
    components: {
        CreateButton,
        'data-filter': DataFilter,
        'create-dialog': CreateDialog,
        'create-dialog2': CreateDialog2,
        MyBreadcrumb

    },
    props: ["breadcrumbs", "icon"],
    watch: {
        dialog(val) {
            if(!this.dialog)
                this.item=null;
        },
        dialogYearlyExport(val)
        {
            if(val){

            }
            else{
                this.dialogYearlyExportFilter.employeeCodes = [],
                this.dialogYearlyExportFilter.departmentCodes = []
            }
        },
        tableParams: {
            handler (val) {
                this.fetchData();
            },
            deep: true,
        },
        // filters: {
        //     handler (val) {
        //         this.tableParams.page=1;
        //         this.fetchData();
        //     },
        //     deep: true,
        // },

        'yearlyFilters.employeeCode'() {
            this.matrixPage = 1;
        },
        'yearlyFilters.employeeName'() {
            this.matrixPage = 1;
        },
        selectedYear(newYear) {
            this.matrixPage = 1;
            if (newYear) {
                this.fetchYearlyLeaves();
            }
        },
        activeTab(val) {
            if (val === 1 && !this.hasFetchedYearly) {
                this.fetchYearlyLeaves();
            }
        },
    },
    computed: {
        params: function() {
            return {...this.tableParams, ...this.filters}
        },
        // Nguồn dữ liệu phép năm: ưu tiên từ API leaveEnrollment2s/year
        yearlyLeaveSource() {
            if (this.hasFetchedYearly) {
                return this.yearlyLeaves || [];
            }
            return (this.yearlyLeaves && this.yearlyLeaves.length > 0) ? this.yearlyLeaves : (this.mockYearlyLeaves || []);
        },
        // Lọc danh sách dữ liệu phép năm theo năm, mã nhân viên, tên nhân viên và loại biến động
        filteredYearlyLeaves() {
            let data = this.yearlyLeaveSource || [];
            if (this.selectedYear) {
                data = data.filter(item => {
                    const targetDate = this.getLeaveItemDate(item);
                    const itemYear = targetDate ? targetDate.year() : null;
                    const fromYear = item.validFrom ? moment(item.validFrom).year() : null;
                    const toYear = item.validTo ? moment(item.validTo).year() : null;
                    return itemYear == this.selectedYear || fromYear == this.selectedYear || toYear == this.selectedYear;
                });
            }
            if (this.yearlyFilters.employeeCode) {
                const code = this.yearlyFilters.employeeCode.toLowerCase().trim();
                data = data.filter(item => (item.employeeCode || '').toLowerCase().includes(code));
            }
            if (this.yearlyFilters.employeeName) {
                const name = this.yearlyFilters.employeeName.toLowerCase().trim();
                data = data.filter(item => (item.employeeName || '').toLowerCase().includes(name));
            }
            if (this.yearlyFilters.type === 'issuing') {
                data = data.filter(item => Number(item.amount) > 0);
            } else if (this.yearlyFilters.type === 'used') {
                data = data.filter(item => Number(item.amount) < 0);
            }
            return data;
        },
        // Thống kê nhanh tổng cấp, tổng dùng, số nhân sự
        yearlyLeaveSummary() {
            const list = this.filteredYearlyLeaves || [];
            const totalIssuing = list.filter(i => Number(i.amount) > 0).reduce((sum, i) => sum + Number(i.amount), 0);
            const totalUsed = list.filter(i => Number(i.amount) < 0).reduce((sum, i) => sum + Math.abs(Number(i.amount)), 0);
            const uniqueEmployees = new Set(list.map(i => i.employeeCode)).size;
            return {
                totalIssuing: Math.round(totalIssuing * 10) / 10,
                totalUsed: Math.round(totalUsed * 10) / 10,
                uniqueEmployees,
                remain: Math.round((totalIssuing - totalUsed) * 10) / 10
            };
        },
        // Danh sách nhân sự duy nhất sau khi lọc
        matrixEmployees() {
            let list = this.yearlyLeaveSource || [];
            if (this.selectedYear) {
                list = list.filter(item => {
                    const targetDate = this.getLeaveItemDate(item);
                    const itemYear = targetDate ? targetDate.year() : null;
                    const fromYear = item.validFrom ? moment(item.validFrom).year() : null;
                    const toYear = item.validTo ? moment(item.validTo).year() : null;
                    return itemYear == this.selectedYear || fromYear == this.selectedYear || toYear == this.selectedYear;
                });
            }
            const empMap = new Map();
            list.forEach(item => {
                if (!empMap.has(item.employeeCode)) {
                    empMap.set(item.employeeCode, {
                        employeeCode: item.employeeCode,
                        employeeName: item.employeeName
                    });
                }
            });

            let employees = Array.from(empMap.values());
            if (this.yearlyFilters.employeeCode) {
                const code = this.yearlyFilters.employeeCode.toLowerCase().trim();
                employees = employees.filter(e => (e.employeeCode || '').toLowerCase().includes(code));
            }
            if (this.yearlyFilters.employeeName) {
                const name = this.yearlyFilters.employeeName.toLowerCase().trim();
                employees = employees.filter(e => (e.employeeName || '').toLowerCase().includes(name));
            }
            return employees;
        },
        // Tính ma trận 12 tháng: từng ô tháng có số ngày cấp, đã dùng, và số ngày còn lại (luỹ kế)
        // Sử dụng ApplyDate (ngày sử dụng phép) để xác định chính xác phép thuộc tháng nào
        monthlyMatrixData() {
            const employees = this.matrixEmployees;
            const year = Number(this.selectedYear) || moment().year();

            return employees.map(emp => {
                const empRecords = (this.yearlyLeaveSource || []).filter(item => {
                    if (item.employeeCode !== emp.employeeCode) return false;
                    const targetDate = this.getLeaveItemDate(item);
                    const itemYear = targetDate ? targetDate.year() : null;
                    const fromYear = item.validFrom ? moment(item.validFrom).year() : null;
                    const toYear = item.validTo ? moment(item.validTo).year() : null;
                    return itemYear === year || fromYear === year || toYear === year;
                });

                let runningBalance = 0;
                const months = [];

                for (let m = 1; m <= 12; m++) {
                    const monthRecords = empRecords.filter(item => {
                        const targetDate = this.getLeaveItemDate(item);
                        return targetDate && targetDate.year() === year && (targetDate.month() + 1) === m;
                    });

                    const issued = monthRecords
                        .filter(item => Number(item.amount) > 0)
                        .reduce((sum, item) => sum + Number(item.amount), 0);

                    const used = monthRecords
                        .filter(item => Number(item.amount) < 0)
                        .reduce((sum, item) => sum + Math.abs(Number(item.amount)), 0);

                    runningBalance = Math.round((runningBalance + issued - used) * 10) / 10;

                    months.push({
                        month: m,
                        issued: Math.round(issued * 10) / 10,
                        used: Math.round(used * 10) / 10,
                        remain: runningBalance,
                        hasActivity: (issued > 0 || used > 0),
                        hasIssued: issued > 0,
                        hasUsed: used > 0,
                        details: monthRecords
                    });
                }

                const totalIssued = months.reduce((sum, m) => sum + m.issued, 0);
                const totalUsed = months.reduce((sum, m) => sum + m.used, 0);
                const yearRemain = Math.round((totalIssued - totalUsed) * 10) / 10;

                const rowObj = {
                    employeeCode: emp.employeeCode,
                    employeeName: emp.employeeName,
                    months,
                    totalIssued: Math.round(totalIssued * 10) / 10,
                    totalUsed: Math.round(totalUsed * 10) / 10,
                    yearRemain
                };
                for (let m = 1; m <= 12; m++) {
                    rowObj[`m${m}`] = months[m - 1];
                }
                return rowObj;
            });
        },
        // Phân trang dữ liệu ma trận
        paginatedMatrixData() {
            if (this.matrixPerPage === -1) {
                return this.monthlyMatrixData;
            }
            const start = (this.matrixPage - 1) * this.matrixPerPage;
            return this.monthlyMatrixData.slice(start, start + this.matrixPerPage);
        },
        matrixPageCount() {
            if (this.matrixPerPage === -1 || !this.monthlyMatrixData.length) return 1;
            return Math.ceil(this.monthlyMatrixData.length / this.matrixPerPage);
        }
    },
    data () {
        return {
            activeTab: 0,
            selectedYear: moment().year(),
            yearlyViewMode: 'matrix', // 'matrix': Ma trận 12 tháng, 'list': Chi tiết biến động
            matrixPage: 1,
            matrixPerPage: 10,
            // Cột hiển thị bảng ma trận phép năm 12 tháng
            monthlyMatrixHeaders: [
                { text: 'Mã NS', value: 'employeeCode', width: '100px', class: 'font-weight-bold text-center sticky-col-code-header', cellClass: 'sticky-col-code text-center' },
                { text: 'Họ và tên', value: 'employeeName', width: '180px', class: 'font-weight-bold sticky-col-name-header', cellClass: 'sticky-col-name' },
                { text: 'Tháng 1', value: 'm1', align: 'center', width: '105px', sortable: false, class: 'font-weight-bold text-center month-col-header' },
                { text: 'Tháng 2', value: 'm2', align: 'center', width: '105px', sortable: false, class: 'font-weight-bold text-center month-col-header' },
                { text: 'Tháng 3', value: 'm3', align: 'center', width: '105px', sortable: false, class: 'font-weight-bold text-center month-col-header' },
                { text: 'Tháng 4', value: 'm4', align: 'center', width: '105px', sortable: false, class: 'font-weight-bold text-center month-col-header' },
                { text: 'Tháng 5', value: 'm5', align: 'center', width: '105px', sortable: false, class: 'font-weight-bold text-center month-col-header' },
                { text: 'Tháng 6', value: 'm6', align: 'center', width: '105px', sortable: false, class: 'font-weight-bold text-center month-col-header' },
                { text: 'Tháng 7', value: 'm7', align: 'center', width: '105px', sortable: false, class: 'font-weight-bold text-center month-col-header' },
                { text: 'Tháng 8', value: 'm8', align: 'center', width: '105px', sortable: false, class: 'font-weight-bold text-center month-col-header' },
                { text: 'Tháng 9', value: 'm9', align: 'center', width: '105px', sortable: false, class: 'font-weight-bold text-center month-col-header' },
                { text: 'Tháng 10', value: 'm10', align: 'center', width: '105px', sortable: false, class: 'font-weight-bold text-center month-col-header' },
                { text: 'Tháng 11', value: 'm11', align: 'center', width: '105px', sortable: false, class: 'font-weight-bold text-center month-col-header' },
                { text: 'Tháng 12', value: 'm12', align: 'center', width: '105px', sortable: false, class: 'font-weight-bold text-center month-col-header' },
                { text: 'Tổng cả năm', value: 'yearTotal', align: 'center', width: '125px', sortable: false, class: 'font-weight-bold text-center total-col-header' },
            ],
            // Bộ lọc dữ liệu xem phép năm
            yearlyFilters: {
                employeeCode: '',
                employeeName: '',
                type: ''
            },
            // Trạng thái dữ liệu từ API leaveEnrollment2s/year
            yearlyLeaves: [],
            yearlyLoading: false,
            hasFetchedYearly: false,
            // Cấu hình cột bảng xem phép năm
            yearlyLeaveHeaders: [
                { text: 'Mã NV', value: 'employeeCode', width: '110px', class: 'font-weight-bold' },
                { text: 'Họ và tên', value: 'employeeName', width: '180px', class: 'font-weight-bold' },
                { text: 'Mã phép', value: 'leavePlanCode', width: '110px', class: 'font-weight-bold' },
                { text: 'Loại phép', value: 'leavePlanName', class: 'font-weight-bold' },
                { text: 'Biến động', value: 'type', align: 'center', width: '130px', class: 'font-weight-bold' },
                { text: 'Số ngày', value: 'amount', align: 'center', width: '110px', class: 'font-weight-bold' },
                { text: 'Ngày sử dụng', value: 'applyDate', width: '130px', class: 'font-weight-bold' },
                { text: 'Từ ngày', value: 'validFrom', width: '120px', class: 'font-weight-bold' },
                { text: 'Đến ngày', value: 'validTo', width: '120px', class: 'font-weight-bold' },
            ],
            // Dữ liệu mẫu (fake data) gồm: employeeCode, employeeName, amount (dương: cấp phép, âm: đã dùng), leavePlanCode, leavePlanName, applyDate, validFrom, validTo
            mockYearlyLeaves: [
                {
                    employeeCode: 'NS0560',
                    employeeName: 'Nguyễn Văn An',
                    amount: 12,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '',
                    validFrom: '2026-01-01',
                    validTo: '2026-12-31'
                },
                {
                    employeeCode: 'NS0560',
                    employeeName: 'Nguyễn Văn An',
                    amount: 1,
                    leavePlanCode: 'PNTN2026',
                    leavePlanName: 'Phép thâm niên 2026',
                    applyDate: '',
                    validFrom: '2026-01-01',
                    validTo: '2026-12-31'
                },
                {
                    employeeCode: 'NS0560',
                    employeeName: 'Nguyễn Văn An',
                    amount: -1,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-02-10',
                    validFrom: '2026-02-10',
                    validTo: '2026-02-10'
                },
                {
                    employeeCode: 'NS0560',
                    employeeName: 'Nguyễn Văn An',
                    amount: -0.5,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-03-15',
                    validFrom: '2026-03-15',
                    validTo: '2026-03-15'
                },
                {
                    employeeCode: 'NS0560',
                    employeeName: 'Nguyễn Văn An',
                    amount: -1,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-07-22',
                    validFrom: '2026-07-22',
                    validTo: '2026-07-22'
                },
                {
                    employeeCode: 'NS0560',
                    employeeName: 'Nguyễn Văn An',
                    amount: -1,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-11-05',
                    validFrom: '2026-11-05',
                    validTo: '2026-11-05'
                },
                {
                    employeeCode: 'NS1253',
                    employeeName: 'Trần Thị Bích',
                    amount: 12,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '',
                    validFrom: '2026-01-01',
                    validTo: '2026-12-31'
                },
                {
                    employeeCode: 'NS1253',
                    employeeName: 'Trần Thị Bích',
                    amount: -2,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-04-20',
                    validFrom: '2026-04-20',
                    validTo: '2026-04-21'
                },
                {
                    employeeCode: 'NS1253',
                    employeeName: 'Trần Thị Bích',
                    amount: -1,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-06-05',
                    validFrom: '2026-06-05',
                    validTo: '2026-06-05'
                },
                {
                    employeeCode: 'NS1253',
                    employeeName: 'Trần Thị Bích',
                    amount: -1,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-10-18',
                    validFrom: '2026-10-18',
                    validTo: '2026-10-18'
                },
                {
                    employeeCode: 'NS0246',
                    employeeName: 'Lê Hoàng Nam',
                    amount: 12,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '',
                    validFrom: '2026-01-01',
                    validTo: '2026-12-31'
                },
                {
                    employeeCode: 'NS0246',
                    employeeName: 'Lê Hoàng Nam',
                    amount: 2,
                    leavePlanCode: 'PNTN2026',
                    leavePlanName: 'Phép thâm niên 2026',
                    applyDate: '',
                    validFrom: '2026-01-01',
                    validTo: '2026-12-31'
                },
                {
                    employeeCode: 'NS0246',
                    employeeName: 'Lê Hoàng Nam',
                    amount: -1,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-01-15',
                    validFrom: '2026-01-15',
                    validTo: '2026-01-15'
                },
                {
                    employeeCode: 'NS0246',
                    employeeName: 'Lê Hoàng Nam',
                    amount: -1,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-05-18',
                    validFrom: '2026-05-18',
                    validTo: '2026-05-18'
                },
                {
                    employeeCode: 'NS0246',
                    employeeName: 'Lê Hoàng Nam',
                    amount: -2,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-12-24',
                    validFrom: '2026-12-24',
                    validTo: '2026-12-25'
                },
                {
                    employeeCode: 'NS1329',
                    employeeName: 'Phạm Minh Tuấn',
                    amount: 12,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '',
                    validFrom: '2026-01-01',
                    validTo: '2026-12-31'
                },
                {
                    employeeCode: 'NS1329',
                    employeeName: 'Phạm Minh Tuấn',
                    amount: -1.5,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-07-08',
                    validFrom: '2026-07-08',
                    validTo: '2026-07-09'
                },
                {
                    employeeCode: 'NS1329',
                    employeeName: 'Phạm Minh Tuấn',
                    amount: -1,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-08-25',
                    validFrom: '2026-08-25',
                    validTo: '2026-08-25'
                },
                {
                    employeeCode: 'NS3270',
                    employeeName: 'Đỗ Hải Đăng',
                    amount: 12,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '',
                    validFrom: '2026-01-01',
                    validTo: '2026-12-31'
                },
                {
                    employeeCode: 'NS3270',
                    employeeName: 'Đỗ Hải Đăng',
                    amount: -1,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-08-12',
                    validFrom: '2026-08-12',
                    validTo: '2026-08-12'
                },
                {
                    employeeCode: 'NS0531',
                    employeeName: 'Vũ Thảo My',
                    amount: 12,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '',
                    validFrom: '2026-01-01',
                    validTo: '2026-12-31'
                },
                {
                    employeeCode: 'NS0531',
                    employeeName: 'Vũ Thảo My',
                    amount: 1,
                    leavePlanCode: 'PNTN2026',
                    leavePlanName: 'Phép thâm niên 2026',
                    applyDate: '',
                    validFrom: '2026-01-01',
                    validTo: '2026-12-31'
                },
                {
                    employeeCode: 'NS0531',
                    employeeName: 'Vũ Thảo My',
                    amount: -3,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-09-01',
                    validFrom: '2026-09-01',
                    validTo: '2026-09-03'
                },
                {
                    employeeCode: 'NS0188',
                    employeeName: 'Hoàng Quốc Việt',
                    amount: 12,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '',
                    validFrom: '2026-01-01',
                    validTo: '2026-12-31'
                },
                {
                    employeeCode: 'NS0188',
                    employeeName: 'Hoàng Quốc Việt',
                    amount: -0.5,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-10-15',
                    validFrom: '2026-10-15',
                    validTo: '2026-10-15'
                },
                {
                    employeeCode: 'NS0188',
                    employeeName: 'Hoàng Quốc Việt',
                    amount: -1,
                    leavePlanCode: 'PN2026',
                    leavePlanName: 'Phép năm 2026',
                    applyDate: '2026-12-10',
                    validFrom: '2026-12-10',
                    validTo: '2026-12-10'
                }
            ],
            ROOT_URL: "leaveEnrollments/",
            breadcrumb: [
                {text: "Danh sách nhân viên ", to: {name: 'Employee'}}
            ],

            //filter
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            filters:{
                code: null,
                employeeCode: null,
                employeeName: null,
                deparmentCode: null,
                amountType: "",
            },

            weekLeaveAssignDialog: false,
            weekLeave: {
                employeeCode: '',
                month: ''
            },

            amountTypes: [{text: "Được cấp", value:"gt"}, {text: "Sử dụng", value:"lt"},{text: "Tất cả", value:""}],
            departmentSearch:null,
            departments: [],
            leavePlans:[],
            rowCount: 0,

            filter: {
                menu: false,
                search: "",
                searchAttr: "name",
                searchAttrs: undefined,
                FilterAttrs: [],
                FilterOn:["DepartmentTypeCode"],
                
                from: undefined,
                to: undefined,
                fromOns: [
                ],
                fromOn: "",
            },

            employees: [],
            expandedEmployees: [],
            employeeHeaders: [
                { text: 'Mã', value: 'code', width: '7rem', 
                    filter: value => {
                    if (!this.filters.employeeCode) return true
        
                    return value.includes(this.filters.employeeCode)
                    }
                },
                { text: 'Tên', value: 'name', 
                    filter: value => {
                    if (!this.filters.employeeName) return true
        
                    return value.includes(this.filters.employeeName)
                    }
                },
                { text: 'Giới tính', value: 'gender'},
                { text: 'Phòng ban', value: 'departmentCode', class: "d-none", cellClass: "d-none", 
                    filter: value => {
                    if (!this.filters.departmentCode) return true
        
                    return value.includes(this.filters.departmentCode)
                    }
                },
                { text: 'Phòng ban', value: 'departmentName'},
                { text: 'Vị trí', value: 'positionName'},
                { text: 'Chức danh', value: 'positionStateName'},
                { text: '', value: 'data-table-expand' },
            ],
            employeeEnrollments: [],
            employeeEnrollmentHeaders: [
                { text: 'Loại phép', value: 'leaveName', class: "black--text", cellClass: "font-weight-bold"},
                { text: 'Từ ngày', value: 'validFrom', class: "black--text"},
                { text: 'Đến ngày', value: 'validTo', class: "black--text"},
                { text: 'Giới hạn phép', value: 'hasAmount', class: "black--text"},
                { text: 'Số phép', value: 'amount', class: "black--text"}
            ],
            
            // VIEW DATA
            filterOpen: 1,
            excelFilter: {
                fromTo: [moment().format('YYYY-MM-DD'), '2100-01-01'],
                leavePlanCode: ''
            },
            exportLoading: false,

            //DATA TABLE
            totalItem: 0,
            items: [],
            search:"",
            options: {},
            isLoading: true,

            dialog: false, item: null,
            dialogDelete: false,
            targetItem: undefined,
            exportPrompt: false,
            headers: [
                { text: 'Thao tác', value: 'actions', width: '7rem'},
                // { text: 'Mã', align: 'start', value: 'code', width: 200},
                { text: 'Mã nhân viên', align: 'start', value: 'employeeCode', width: 100},
                { text: 'Nhân viên', align: 'start', value: 'employeeName', width: 200},
                { text: 'Phòng', align: 'start', value: 'department', width: 200},
                { text: 'Phép', align: 'start', value: 'leavePlanName', width: 200},
                { text: 'Số lượng', align: 'start', value: 'total', width: 200},

                // { text: 'Hiện tại', value: 'isCurrent', width: 200},
                { text: 'Tạo vào', value: 'createdAt', width: 200 },
                { text: 'Thời hạn từ', value: 'validFrom', width: 200},
                { text: 'Thời hạn đến', value: 'validTo', width: 200},
            ],

            dialogYearlyExport: false,
            dialogYearlyExportFilter: {
                employees:[],
                departments:[],
            },
            dialogYearlyExportFilterData: {
                employeeCodes:[],
                departmentCodes:[],
            },
            dialogReportExport: false,
            dialogReportExportData: {
                departmentCode: "",
                employeeCode:"" 
            },
            
            monthlyDialog: false,
            monthlyForm: {
                month: ""
            }
        }
    },
    methods: {
        formatDate(value, format = "DD/MM/YYYY") {
            if (!value) return '';
            const m = moment(value);
            return m.isValid() ? m.format(format) : '';
        },
        // Xác định ngày áp dụng của bản ghi phép:
        // - Đối với ngày sử dụng phép (hoặc bản ghi có applyDate), ưu tiên applyDate để biết phép sử dụng tháng nào.
        // - Nếu không có applyDate, lấy validFrom hoặc validTo.
        getLeaveItemDate(item) {
            if (!item) return null;
            const dateStr = item.applyDate || item.ApplyDate || item.validFrom || item.ValidFrom || item.validTo || item.ValidTo;
            if (!dateStr) return null;
            const m = moment(dateStr);
            return m.isValid() ? m : null;
        },
        fetchEmployee() {
            return http.get("employees/simple").then(r => {
                this.employees = r.data
            })
        },
        
        formatTime(value) {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        fetchDepartment() {
            return http.get("departments/fetch", {
                params: {
                    search: this.departmentSearch
                }
            }).then(res => {
                this.departments = res.data;
            })
        },
        fetchLeavePlan() {
            return http.get("leavePlans").then(res => {
                this.leavePlans = res.data;
                console.log(res.data)
            })
        },

        exportExcel() {
            this.exportLoading = true
            return ApiServices.getExport("leaveEnrollments", this.excelFilter, "PHEP_NV").then(() => this.exportLoading = false)
        },

        fetchData () {
            return http.get(this.ROOT_URL, {
                params: this.params
            })
            .then(res => {
                this.isLoading = false;
                this.items = res.data.results;
                this.rowCount = res.data.rowCount;
            })
            .catch(err => {

            })
        },
        fetchEmployeeLeaveEnrollments(employeeCode) {
            return http.get('leaveEnrollments/fetch-amount/'+employeeCode).then(r => {
                this.employeeEnrollments = r.data.data
            })
        },
        edit(item){
            this.item = item;
            this.dialog = true;
        },
        
        remove(item){
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            console.log(this.targetItem);
            return http.delete(this.ROOT_URL+this.targetItem.employeeCode+"/"+this.targetItem.leavePlanCode).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            })
        },
        monthlyDistribute() {
            return http.get("leaveEnrollments/monthly-distribute", {
                params: this.monthlyForm
            }).then(r => {this.monthlyDialog=false})
        },
        reportExport() {
            return http.get("leaveEnrollments/report-export", {
                // params: this.exportWorkingFilter,
                responseType: 'blob',
            }).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `DANH_SACH_PHEP.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
        },
        employeeExpandHandler() {
            let currentEmployeeCode = this.expandedEmployees[0]
            console.log("load enrollments", currentEmployeeCode)
            if(currentEmployeeCode) {
                this.fetchEmployeeLeaveEnrollments(currentEmployeeCode.code)
            }
        },
        weekAssignSubmit() {
            return http.get("leaveEnrollments/week-assign", {
                params: {
                    employeeCode: this.weekLeave.employeeCode,
                    month: this.weekLeave.month
                }
            })
        },

        resetWeekAssign() {
            this.weekLeave.employeeCode = ''
            this.weekLeave.month = ''
            this.weekLeaveAssignDialog = false
        },

        // Gọi API [HttpGet("year")] public IActionResult GetByYear([FromQuery] DateTime year) trên controller leaveEnrollment2s
        fetchYearlyLeaves() {
            this.yearlyLoading = true;
            // Chuẩn hóa định dạng ngày gửi lên C# DateTime binder: YYYY-01-01
            const yearDate = moment(`${this.selectedYear}-01-01`).isValid()
                ? moment(`${this.selectedYear}-01-01`).format('YYYY-MM-DD')
                : moment().format('YYYY-01-01');

            return http.get('leaveEnrollment2s/year', {
                params: {
                    year: yearDate
                }
            })
            .then(res => {
                this.yearlyLoading = false;
                this.hasFetchedYearly = true;
                let rawData = [];
                if (Array.isArray(res.data)) {
                    rawData = res.data;
                } else if (res.data && Array.isArray(res.data.data)) {
                    rawData = res.data.data;
                } else if (res.data && Array.isArray(res.data.results)) {
                    rawData = res.data.results;
                } else if (res.data && typeof res.data === 'object') {
                    rawData = Object.values(res.data).find(v => Array.isArray(v)) || [];
                }

                // Chuẩn hóa dữ liệu trả về từ backend (hỗ trợ cả camelCase và PascalCase)
                this.yearlyLeaves = rawData.map(item => ({
                    employeeCode: item.employeeCode || item.EmployeeCode || '',
                    employeeName: item.employeeName || item.EmployeeName || '',
                    amount: Number(item.amount !== undefined ? item.amount : (item.Amount !== undefined ? item.Amount : 0)),
                    leavePlanCode: item.leavePlanCode || item.LeavePlanCode || '',
                    leavePlanName: item.leavePlanName || item.LeavePlanName || '',
                    applyDate: item.applyDate || item.ApplyDate || '',
                    validFrom: item.validFrom || item.ValidFrom || '',
                    validTo: item.validTo || item.ValidTo || '',
                    raw: item
                }));
            })
            .catch(err => {
                this.yearlyLoading = false;
                this.hasFetchedYearly = true;
                console.error("Lỗi khi tải dữ liệu từ leaveEnrollment2s/year:", err);
            });
        }
    },
    created () {
        this.fetchEmployee();
        // this.fetchData();
        this.fetchLeavePlan();
        this.fetchYearlyLeaves();
    }
}